import script from "./PageButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageButton.vue?vue&type=script&setup=true&lang=ts"

import "./PageButton.vue?vue&type=style&index=0&id=71e5a15a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/ClementRivaille.github.io/ClementRivaille.github.io/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71e5a15a"]])

export default __exports__